import type { SimulationSnapshot, Vector3 } from "../simulation/types";
import { add, cross, dot, normalize, scale } from "../simulation/vector";

export interface ObserverFrame {
  readonly right: Vector3;
  readonly up: Vector3;
  readonly towardCamera: Vector3;
  readonly lightLocal: Vector3;
  readonly lightTowardCamera: number;
}

export function getObserverFrame(snapshot: SimulationSnapshot): ObserverFrame {
  const towardCamera = normalize(snapshot.moonToEarth);
  const up = normalize(
    add(
      snapshot.orbitalNormal,
      scale(towardCamera, -dot(snapshot.orbitalNormal, towardCamera)),
    ),
  );
  const right = normalize(cross(up, towardCamera));
  const lightTowardCamera = dot(snapshot.moonToSun, towardCamera);

  return {
    right,
    up,
    towardCamera,
    lightLocal: [
      dot(snapshot.moonToSun, right),
      dot(snapshot.moonToSun, up),
      lightTowardCamera,
    ],
    lightTowardCamera,
  };
}
